import { useStateWithCallbackLazy } from 'use-state-with-callback';

import useAuth from 'hooks/useAuth';
import { identify } from 'utils/analyticsUtils';

// Not intended to be used more than once, on App.jsx
const useAnalyticsIdentify = ({ account, isAnalyticsReady, subscription }) => {
    const { authStatus } = useAuth();

    const [isAnalyticsInitialized, setIsAnalyticsInitialized] = useStateWithCallbackLazy(false);

    if (authStatus === 'authenticated' && !isAnalyticsInitialized && isAnalyticsReady) {
        setIsAnalyticsInitialized(true, () => identify({ account, subscription }));
    }

    return [isAnalyticsInitialized, setIsAnalyticsInitialized];
};

export default useAnalyticsIdentify;
